import { useLayer } from "./useLayer";
import { useContent } from "./useContent";
import { useMemo } from "react";

export function useLayerFigures() {
  const { figures: allFigures } = useContent();

  const layer = useLayer();

  const figures = useMemo(() => {
    switch (layer.type) {
      case "content":
        return allFigures.content;
      case "excursion":
        if (!layer.slug || !allFigures.excursions[layer.slug ?? ""]) return [];
        return allFigures.excursions[layer.slug] ?? [];
      default:
        return [];
    }
  }, [allFigures, layer]);

  return figures;
}
